import html2canvas from 'html2canvas';

const html2canvas_ = html2canvas;

export default {
	data() {
		return {
			html2canvas: html2canvas_
		}
	}
}